module.exports = __webpack_public_path__ + "img/join_content_2__slider_1.b11b3af2.png";